import { render, staticRenderFns } from "./Paket.vue?vue&type=template&id=38db26f4"
import script from "./Paket.vue?vue&type=script&lang=js"
export * from "./Paket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports